import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { isChild } from "Utils/ageUtils";
import { reverseAndPadDDMMYYYY } from "Utils/dateUtils";
import { firstNameSchema } from "Validation/index";
import { AKA_CHILD_MAX_AGE } from "../akaChildConstants";
import { AkaChildProductDetailsFormValues } from "./akaChildProductDetailsInterfaces";

export const validationSchema =
  () => (): Yup.ObjectSchema<AkaChildProductDetailsFormValues> => {
    const { getText } = TextManager;
    return Yup.object({
      childFirstName: firstNameSchema(),
      childBirthDate: Yup.string()
        .min(6, getText("childform.validation.childbirthdate-format"))
        .test(
          "childBirthDate",
          getText("childform.validation.childbirthdate-not_child"),
          (value) => {
            return value
              ? isChild(
                  new Date(reverseAndPadDDMMYYYY(value)),
                  AKA_CHILD_MAX_AGE,
                )
              : true;
          },
        )
        .required(getText("childform.validation.childbirthdate-required")),
    }).defined();
  };
